export default class Infrastructure {
  constructor(parent) {
    const contents = [].slice.call(parent.querySelectorAll('.infrastructure__item'));
    const tabs = [].slice.call(parent.querySelectorAll('.infrastructure__list-tab'));
    const contentBlocks = [].slice.call(parent.querySelectorAll('.infrastructure__item-content'));
    this.isChrome = /Chrome/.test(window.navigator.userAgent) && /Google Inc/.test(window.navigator.vendor);

    if (tabs.length > 0 && contents.length > 0) {
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          if (!tab.classList.contains('infrastructure__list-tab--active')) {
            tabs.forEach(el => el.classList.remove('infrastructure__list-tab--active'));
            contents.forEach(el => el.classList.remove('infrastructure__item--active'));
            tab.classList.add('infrastructure__list-tab--active');
            contents[index].classList.add('infrastructure__item--active');
          }
        });
      });
    }

    if (contentBlocks.length > 0) {
      contentBlocks.forEach((block) => {
        block.addEventListener('click', (e) => {
          if (e.target.classList.contains('infrastructure__more')) {
            if (this.isChrome) {
              this.position = window.pageYOffset;
            }
            block.classList.toggle('infrastructure__item-content--hide-blocks');
            this.constructor.toggleBtnText(e.target);
            if (this.isChrome) {
              window.scrollTo(0, this.position);
            }
          }
        });
      });
    }
  }

  static toggleBtnText(btn) {
    const condition = btn.textContent === btn.getAttribute('data-s');
    btn.textContent = condition ? btn.getAttribute('data-h') : btn.getAttribute('data-s');
  }
}



// WEBPACK FOOTER //
// ./new-blocks/infrastructure/infrastructure.js